import React from 'react';

function normalize(value) {
  return String(value || '')
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

function variantFor(value) {
  const key = String(value || '').toLowerCase();
  if (['active', 'on_track', 'green', 'done', 'closed', 'met'].includes(key)) return 'success';
  if (['planned', 'draft', 'in_progress', 'yellow'].includes(key)) return 'info';
  if (['at_risk', 'blocked', 'red', 'missed', 'off_track'].includes(key)) return 'warn';
  return 'neutral';
}

function StatusBadge({ value }) {
  return <span className={`badge badge-${variantFor(value)}`}>{normalize(value) || 'Unknown'}</span>;
}

export default StatusBadge;
